import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CustomerSuccessDetailService from '../services/CustomerSuccessDetailService';
import CustomerSuccessCompanyDetailScene from './CustomerSuccessCompanyDetailScene';

class CustomerSuccessCompanyDetailSceneContainer extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      type: PropTypes.string,
      typeId: PropTypes.string,
      companyId: PropTypes.string,
    }),
  };

  customerSuccessDetailService = new CustomerSuccessDetailService();
  componentDidMount() {
    this.customerSuccessDetailService.loadCompany(this.props.params.companyId);

    if (this.props.params.type === 'segment') {
      this.customerSuccessDetailService.loadSegment(this.props.params.typeId);
    }
    if (this.props.params.type === 'distributor') {
      this.customerSuccessDetailService.loadDistributor(this.props.params.typeId);
    }
  }

  render() {
    return (
      <CustomerSuccessCompanyDetailScene
        isLoading={
          !toJS(this.customerSuccessDetailService.company) ||
          this.customerSuccessDetailService.fetchCompany.fetching ||
          this.customerSuccessDetailService.fetchSegment.fetching ||
          this.customerSuccessDetailService.fetchDistributor.fetching
        }
        company={toJS(this.customerSuccessDetailService.company)}
        segment={toJS(this.customerSuccessDetailService.segment)}
        distributor={toJS(this.customerSuccessDetailService.distributor)}
        type={this.props.params.type}
        typeId={this.props.params.typeId}
        companyId={this.props.params.companyId}
      />
    );
  }
}
export default observer(CustomerSuccessCompanyDetailSceneContainer);
